export default "__VITE_ASSET__BtMOZgs3__"